import axios from 'axios';

// Configuration
const API_BASE_URL = 'https://bitget.zkcandy.io'; //or okx. or layer3.
const API_KEY = '0529c385-62ce-4d60-9f1c-bea94d418e1c'; // Default to imba key, can be overridden

export async function createQuest(questName, required = false, points = 0, apiKey = API_KEY) {
    try {
        console.log(`Creating quest: ${questName}`);
        console.log(`Required: ${required}, Points: ${points}`);
        console.log(`Using API Key: ${apiKey.substring(0, 8)}...`);

        const response = await axios.post(`${API_BASE_URL}/create-quest`, {
            quest_name: questName,
            required: required,
            points: points,
            apiKey: apiKey
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 10000 // 10 second timeout
        });

        console.log('✅ Quest created successfully!');
        console.log('Response:', JSON.stringify(response.data, null, 2));
        return response.data;
    } catch (error) {
        console.error('❌ Error creating quest:');

        if (error.response) {
            // Server responded with error status
            console.error('Status:', error.response.status);
            console.error('Response:', JSON.stringify(error.response.data, null, 2));
        } else if (error.request) {
            // Request was made but no response received
            console.error('No response received:', error.message);
        } else {
            // Something else happened
            console.error('Error:', error.message);
        }

        throw error;
    }
}

export async function testQuestStatus(questName, address) {
    try {
        console.log(`Testing quest status for: ${questName}`);
        console.log(`Address: ${address}`);

        const response = await axios.get(`${API_BASE_URL}/${questName}`, {
            params: { address: address },
            timeout: 10000
        });

        console.log('✅ Quest status retrieved successfully!');
        console.log('Response:', JSON.stringify(response.data, null, 2));
        return response.data;
    } catch (error) {
        console.error('❌ Error getting quest status:');

        if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Response:', JSON.stringify(error.response.data, null, 2));
        } else {
            console.error('Error:', error.message);
        }

        throw error;
    }
}

export async function markQuestComplete(questName, address, passportId = null, apiKey = API_KEY) {
    try {
        console.log(`Marking quest complete: ${questName}`);
        console.log(`Address: ${address}`);
        if (passportId) console.log(`Passport ID: ${passportId}`);

        const requestBody = {
            quest_name: questName,
            address: address,
            apiKey: apiKey
        };
        if (passportId) {
            requestBody.passportId = passportId;
        }
        const response = await axios.post(API_BASE_URL, requestBody, {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 10000
        });

        console.log('✅ Quest marked complete successfully!');
        console.log('Response:', JSON.stringify(response.data, null, 2));
        return response.data;
    } catch (error) {
        console.error('❌ Error marking quest complete:');

        if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Response:', JSON.stringify(error.response.data, null, 2));
        } else {
            console.error('Error:', error.message);
        }

        throw error;
    }
}